import { createEffect } from "effector";
import { compressImageAsset } from "~/api/assets.api";
import { CompressImagePayload } from "~/api/types";

export const compressImageFx = createEffect(async (payload: CompressImagePayload) => {
  await compressImageAsset(payload);
});
